import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-react'

export function PrimaryButton({
	onClick,
	disabled,
	isLoading,
	children,
}: {
	onClick: () => void
	disabled: boolean
	isLoading: boolean
	children: React.ReactNode
}) {
	return (
		<Button
			onClick={onClick}
			disabled={disabled}
			className="min-h-[48px] w-full rounded-[12px] bg-brand-blue py-[15px] font-medium text-[16px] text-white leading-[100%] hover:bg-brand-blue/90"
		>
			{isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : children}
		</Button>
	)
}
